import { createFileRoute, redirect } from "@tanstack/react-router";
import { deskSearch } from "../../lib/desk/search";

/** The old address of the medal desk's queue, now a tab of Award medals. OVR's "Open in MSES" links here (`?event=`), so the search is kept. */
export const Route = createFileRoute("/_app/desk")({
	validateSearch: deskSearch,
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/award", search, replace: true });
	},
});
